import { apiFetch } from './api'
import { maskToQuery } from './tile-server-client'

export default class Ts2Client {
  constructor(ts2BaseUrl, token) {
    this.baseUrl = ts2BaseUrl
    this.token = token
  }

  /**
   * @typedef {Object} ZonalStatisticsFunction
   * @property {string} function
   * @property {[number, number]|undefined} thresholds
   * @property {[boolean, boolean]|undefined} includeOutliers
   */

  /**
   * @typedef {Object} ZonalStatisticsBand
   * @property {string} band
   * @property {[number, number]|undefined=} thresholds
   * @property {[boolean, boolean]|undefined=} includeOutliers
   */

  /** @typedef {ZonalStatisticsFunction|ZonalStatisticsBand} ZonalStatisticsOp */

  /**
   *
   * @param {ZonalStatisticsOp[]} ops
   * @param {string} bands
   * @param {import('@turf/helpers').FeatureCollection<Polygon>} featureCollection
   * @param {string} source
   * @param {LayerParams} params
   * @returns
   */
  calculateZonalStatistics(
    ops,
    bands,
    featureCollection,
    source,
    params = undefined
  ) {
    var url = `${this.baseUrl}/zonal_statistics/calculate?token=${this.token}`

    return apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        ops,
        bands,
        zones: featureCollection,
        source,
        type: params?.hiDefinition ? 'hi-def' : 'standard',
        percentiles: params?.percentiles,
        ...maskToQuery(params?.mask),
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  generateZonalStatisticsExport(plots, filename, format) {
    var exportUrl =
      this.baseUrl +
      '/zonal_statistics/export?file=' +
      encodeURIComponent(filename) +
      '&format=' +
      format +
      '&token=' +
      this.token
    return window
      .fetch(exportUrl, {
        mode: 'cors',
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(plots),
      })
      .then(
        function (response) {
          if (response.status === 200) {
            return (
              this.baseUrl +
              '/zonal_statistics/download?file=' +
              encodeURIComponent(filename) +
              '&format=' +
              format +
              '&token=' +
              this.token
            )
          } else {
            throw new Error(`Unexpected HTTP response ${response.status}.`)
          }
        }.bind(this)
      )
  }
}
